export enum IPAddressType {
  AUTO = 0,
  STICKY = 1,
  USER_RESERVED = 4,
  DHCP = 5,
  DISCOVERED = 6,
}

export enum SubnetMeta {
  MODEL = "subnet",
  PK = "id",
}
